<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <template v-if="call_type != 'dunning_notice'">
                <div class="container-fluid xyz">
                    <div class="page-header-top-container">
                        <div id="callHeader" class="page-name color-71aa3f">
                            Create {{ LabelName('callsemaillabel') }}
                        </div>
                        <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="back">
                            Back
                        </button>
                    </div>
                    <div v-if="isDataEditable == true">
                        <div class="admin-page-content">
                            <form id="callfrom">
                                <div class="forms-container">
                                    <div class="row no-margin">
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                            <div class="alert alert-success" id="alertSuccess">
                                                <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                                <span>{{ LabelName('callsemaillabel') }} Added Successfully</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                            <div class="alert alert-danger" id="alertError">
                                                <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                                <span id="errorMsg" class="error"></span>
                                            </div>
                                        </div>
                                        <div class="col-6 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Customer</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <v-select v-model="customer_id" v-on:change="changedCustomerValue" name="customer_id"
                                                          label="text" :filterable="false" :options="customersArr"
                                                          @search="onCustomerSearch"
                                                          v-validate="'required'"
                                                          placeholder="Select Customer">
                                                    <template slot="no-options">
                                                        Search Customers...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('customer_id')" class="help is-danger"><font color="red">Customer is Required</font></span>
                                            </div>    
                                        </div>
                                        <div class="col-6 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Contact</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <v-select v-model="contact_id" @change="changedValue"
                                                          name="contact_id" label="text" :filterable="false"
                                                          :options="contactsArr" 
                                                          :searchable="false"
                                                          @search="onContatcSearch"
                                                          v-validate="'required'"
                                                          placeholder="Select Contact">
                                                    <template slot="no-options">
                                                        Search Contacts...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('contact_id')" class="help is-danger"><font color="red">Contact is Required</font></span>
                                            </div>    
                                        </div>
                                        <div class="col-6 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Collector</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <span class="form-control">{{user_id.text}}</span>
                                            </div>    
                                        </div>
                                        <div class="col-6 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Priority</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <v-select
                                                    name="priority"
                                                    v-model="priority"
                                                    id="priority" label="text"
                                                    :options="priorityArr"
                                                    :required="true"
                                                    :clearable=false
                                                    v-validate="'required'"
                                                    ></v-select>
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('priority')" class="help is-danger"><font color="red">Priority is Required</font></span>
                                            </div>    
                                        </div>
                                        <div class="col-6 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Call Date & Time</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="text" id="call_date_time" name="call_date_time"
                                                       class="datetimepicker form-control"
                                                       placeholder="Please choose date & time..."
                                                       v-model="call_date_time"
                                                       v-validate="'required'" disabled="">
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('call_date_time')" class="help is-danger"><font color="red">Call Date & Time is Required</font></span>
                                            </div>    
                                        </div>
                                        <div class="col-6 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Category</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <v-select
                                                    name="category"
                                                    v-model="category"
                                                    id="category" label="text"
                                                    :options="categoryArr"
                                                    :required="true"
                                                    :value="category"
                                                    v-validate="'required'"
                                                    ></v-select>
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('category')" class="help is-danger"><font color="red">Category is Required</font></span>
                                            </div>    
                                        </div>
                                        <div class="col-6 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Status</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <v-select
                                                    name="status"
                                                    v-model="status"
                                                    id="status" label="text"
                                                    :options="statusArr"
                                                    :value="status"
                                                    ></v-select>
                                            </div>    
                                        </div>
                                        <div class="col-6 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Subject</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="text" id="subject" name="subject" class="form-control"
                                                       placeholder="Enter Subject" v-model="subject" maxlength="190">
                                            </div>    
                                        </div>
                                        
                                        
                                        
                                        <div class="col-6 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Due Date</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                    <input type="date" id="due_date" name="due_date" class="form-control"
                                                    placeholder="Enter Date in MM/DD/YYYY" v-model="due_date"
                                                    >
                                            </div>    
                                        </div>
                                        <div class="col-12 forms-block">
                                            <div class="col-1point5 paddingleft0">
                                                <div class="form-label"><strong>Additional Comments</strong></div>
                                            </div>
                                            <div class="col-10point5 paddingleft0">
                                                <textarea name="notes" id="notes" rows="10"
                                                          class="form-control no-resize"
                                                          placeholder="Enter Additional Comments"
                                                          v-model="notes"></textarea>
                                            </div>    
                                        </div>
                                        <div class="col-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Created By</strong> : {{ firstName }} {{ lastName }}</div>
                                            </div>
                                        </div>
                                        <div class="col-12 ">
                                            <div class="col-12 paddingleft0">
                                                <input id="addCallBtn" type="submit" value="Save" class="btn general-button btn-primary" v-on:click.prevent="AddCall()">
                                                <!-- <button id="addCaseBtn" type="submit" class="btn general-button btn-primary" v-on:click.prevent="addCase">{{btn}}</button> -->
                                                <input id="addAndContinueCallBtn" type="submit" value="Save and Continue" class="btn general-button btn-primary" v-on:click.prevent="AddCall(flag='Save and Continue')">
                                                <input id="CancelCall" type="submit" value="Cancel" class="btn general-button btn-primary" v-on:click.prevent="back">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>    
                        </div>
                    </div>
                    <div v-if="isDataEditable == false" >
                        <div class="admin-page-content">
                            <div class="col-md-12 error-detail-main forms-container">
                                <div class="error-template">
                                    <h1>Oops!</h1>
                                    <!--<h2>403</h2>-->
                                    <div class="error-details">Sorry You can't Edit This Record...</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="admin-page-content">
                    <div class="col-md-12 error-detail-main forms-container">
                        <div class="error-template">
                            <h1>Oops!</h1>
                            <h2>403</h2>
                            <div class="error-details">Sorry!, Dunning Notice entry can't be editable, it's system generated.</div>
                        </div>
                    </div>
                </div>
            </template>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>

</template>
<script>
    import Vue from "vue";
    import vSelect from "vue-select";
    Vue.component("v-select", vSelect);
    import FrontFooter from '@/components/partials/FrontFooter';
    import { addCall, getCustomer } from "../../config";
    import VeeValidate from "vee-validate";
    import SessioMixin from '../../mixins/sessionmixin';
    import EventBus from "../event-bus";
    const Swal = require('sweetalert2');
    Vue.use(VeeValidate);
    var contex;

    var segments = "";
    export default {
        name: "callCreate",
        mixins: [SessioMixin],
        components: {
            'app-footer': FrontFooter,
        },
        data: () => ({
                isShowLoggedinfields: true,
                firstName: "",
                lastName: "",
                userName: "",
                loggedinUserId: "",
                customerId: 0,
                call_type: 'call',
                isLoggedIn: false,
                permissions: [],
                cantAccessPage: true,
                user_id: "",
                userArr: [],
                subject: "",
                notes: "",
                call_date_time: "",
                direction: {value: "outgoing", text: "Outgoing"},
                directionArr: [
                    {
                        value: "incoming",
                        text: "Incoming"
                    },
                    {
                        value: "outgoing",
                        text: "Outgoing"
                    }
                ],
                callType: {value: "call", text: "Call"},
                callTypeArr: [
                    {
                        value: "call",
                        text: "Call"
                    },
                    {
                        value: "email",
                        text: "E-Mail"
                    }
                ],
                status: '',
                statusArr: [
                    {
                        value: "in_progress",
                        text: "In Progress"
                    },
                    {
                        value: "completed",
                        text: "Completed"
                    }
                ],
                due_date: "",
                category:{ value: "collector_initial_contact", text: "Collector – Initial Contact" },
                categoryArr : [
                { value: "collector_initial_contact", text: "Collector – Initial Contact" },
                { value: "collector_follow_up", text: "Collector – Follow Up" },
                { value: "collector_escalation_to_credit_manager", text: "Collector - Escalation to Credit Manager" },
                { value: "credit_manager_initial_contact", text: "Credit Manager - Initial Contact" },
                { value: "ops_branch_account_escalation", text: "OPS/Branch – Account Escalation" },
                { value: "credit_manager_cod_warning", text: "Credit Manager – COD Warning" },
                { value: "credit_manager_cod_notification", text: "Credit Manager – COD Notification" },
                { value: "demand_letter_issued", text: "Demand Letter Issued" },
                { value: "escalation_to_corporate_credit_manager", text: "Escalation to Corporate Credit Manager" },
                { value: "account_adjustment", text: "Account Adjustment (Refund/Write Off/Offset)" },
                { value: "broken_promise_to_pay", text: "Broken Promise to Pay" },
                { value: "customer_inquiry", text: "Customer Inquiry" },
                { value: "credit_balance_review", text: "Credit Balance Review" },
                { value: "credit_override", text: "Credit Override" },
                { value: "credit_application_requested", text: "Credit Application Requested" },
                { value: "credit_limit_review_request", text: "Credit Limit Review Request" },
                { value: "dnc_status", text: "DNC Status (AFDA, Legal, 3rd Party, etc.)" },
                { value: "dispute", text: "Dispute" },
                { value: "promise_to_pay", text: "Promise to Pay" },
                { value: "rebill_request", text: "Rebill Request" },
                { value: "treasury_notification", text: "Treasury Notification" },
                { value: "not_responding", text: "Not Responding" },
                { value: "paid", text: "Paid" },
                { value: "terms_of_credit", text: "Terms Of Credit" },
                { value: "other", text: "Other" }
                ],

                customer_id: "",
                customersArr: [],
                contact_id: "",
                contactsArr: [],
                priority: {value: "medium", text: "Medium"},
                priorityArr: [
                    {
                        value: "high",
                        text: "High"
                    },
                    {
                        value: "medium",
                        text: "Medium"
                    },
                    {
                        value: "low",
                        text: "Low"
                    }
                ],
                isDataEditable: true,
                loginID: "",
                selectedContactId:'',
            }),
        watch: {
            customer_id: function (customer_id) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/contact_details",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        customer_id: customer_id.value
                    },
                    dataType: "json",
                    success: function (data) {
                        if (customer_id.value) {
                            self.contactsArr = data.content;
                            if(self.selectedContactId != '' && self.selectedContactId != undefined){
                                const foundContactIndex = self.contactsArr.findIndex(contact => contact.value === self.selectedContactId);
                                if(foundContactIndex != undefined && foundContactIndex != null){
                                    self.contact_id = {value: data.content[foundContactIndex].value, text: data.content[foundContactIndex].text};
                                    self.selectedContactId = '';
                                }else{
                                    self.contact_id = {value: data.content[0].value, text: data.content[0].text};
                                }
                            }else{
                                self.contact_id = {value: data.content[0].value, text: data.content[0].text};
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            if (jqXHR.status == 401) {
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            contact_id: function (contact_id) {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[2] != 'update') {
                    if (typeof (contact_id) == "undefined" || contact_id == null) {
                        self.user_id = {value: '', text: ''};
                    } else {
                        if (contact_id == '') {
                            self.user_id = {value: '', text: ''};
                        } else {
                            $.ajax({
                                url: process.env.ROOT_API + "/get/contact/user",
                                type: "GET",
                                headers: {
                                    Accept: "application/json",
                                    "Access-Control-Allow-Origin": "*",
                                    Authorization: "Bearer " + localStorage.getItem("api_token"),
                                    "Access-Control-Allow-Headers":
                                            "Origin, Content-Type, Authorization,X-Requested-With",
                                    "Cache-Control": "no-cache"
                                },
                                data: {
                                    contact_id: contact_id.value
                                },
                                dataType: "json",
                                success: function (data) {
                                    if (contact_id.value) {
                                        self.user_id = {value: data[0].value, text: data[0].text};
                                        self.userArr = data;
                                    }
                                },
                                error: function (jqXHR, exception) {
                                    if (jqXHR.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        if (jqXHR.status == 401) {
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            self.$router.push("/login");
                                        }
                                        self.error = jqXHR.responseJSON.message;
                                    }
                                }
                            });
                        }
                    }
                }
            }
        },
        beforeMount: function () {
            var app = this;
            contex = this;
            var check = window.localStorage.getItem("api_token");

            if (check != null) {
                this.isLoggedIn = true;
                app.getPermissions();
            }
        },

        mounted: function () {
            //Textare auto growth
            //autosize($('textarea.auto-growth'));
            //Datetimepicker plugin
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            $(".removeActive").removeClass("active");
            if (segments[2] == 'update') {
                $("#creator").html("Updated By");
                if (segments[4] != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menucalls").addClass("active");
                }
            } else {
                $("#creator").html("Created By");
                //console.log(segments[3]);
                if (segments[3] != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menucalls").addClass("active");
                }
            }
            /*$(".datetimepicker").bootstrapMaterialDatePicker({
             format: "MM/DD/YYYY HH:mm:ss",
             clearButton: true,
             weekStart: 1
             });*/
            self.setDefaultCallDate();
            var self = this;
            if (localStorage.getItem("menu_small") == "1") {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            if (segments[2] == 'update') {
                if (segments[3]) {
                    self.showLoader();
                    self.loadCall();
                    // $("#addAndContinueCallBtn").prop('disabled',true);
                    $("#addAndContinueCallBtn").hide();
                    $("#addCallBtn").val("Update");
                    $("#callHeader").text("Edit Calls/Emails");
                }
            } else {
                if (segments[3] != 0) {
                    self.customerId = segments[3];
                    self.loadCustomeradd();
                }
            }

            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                EventBus.$emit(
                        "logged-in",
                        false,
                        userJson["first_name"],
                        userJson["last_name"],
                        userJson["email"]
                        );
            }
        },

        methods: {
            setDefaultCallDate: function () {
                var self = this;
                var d = new Date();

                var curYear = d.getFullYear();
                var curMonth = ((d.getMonth() + 1) < 10) ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1);
                var cuDate = (d.getDate() < 10) ? "0" + d.getDate() : d.getDate();
                var cuHour = (d.getHours() < 10) ? "0" + d.getHours() : d.getHours();
                var cuMinute = (d.getMinutes() < 10) ? "0" + d.getMinutes() : d.getMinutes();
                var cuSecond = (d.getSeconds() < 10) ? "0" + d.getSeconds() : d.getSeconds();
                self.call_date_time = curMonth + '/' + cuDate + '/' + curYear + ' ' + cuHour + ':' + cuMinute + ':' + cuSecond;
                $("#call_date_time").change(function () {
                    self.call_date_time = $("#call_date_time").val();
                });
            },
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_add_new_calls') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            back: function () {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                if (self.$route.query && self.$route.query.from == 'followup'){
                    self.$router.push("/followup/list");
                }else
                if (segments[2] == 'update') {
                    if (segments[4] != 0) {
                        self.$router.push("/customer/view/" + segments[4]);
                    } else {
                        self.$router.push("/listcall");
                    }
                } else {
                    if (segments[3] != 0) {
                        self.$router.push("/customer/view/" + segments[3]);
                    } else {
                        self.$router.push("/listcall");
                    }
                }
            },
            changedCustomerValue: function (value) {
                //console.log("", value);
            },
            changedValue: function (value) {
                //console.log("", value);
            },
            onUserSearch(search, loading) {
                if (search.length > 2) {
                    loading(true);
                    this.loadUser(loading, search, this);
                }
            },

            onCustomerSearch(search, loading) {
                if (search.length > 2) {
                    loading(true);
                    this.loadCustomer(loading, search, this);
                }
            },

            onContatcSearch(search, loading) {
                /*if (search.length > 2) {
                 loading(true);
                 this.loadCalls(loading, search, this);
                 }*/
            },
            onSubmit(flag) {
                this.$validator.validateAll();

                if (!this.errors.any()) {
                    this.AddCall(flag);
                }
            },
            loadCustomeradd() {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/get/customers",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        default: self.customerId
                    },
                    dataType: "json",
                    success: function (data) {
                        self.customer_id = {value: data[0].value, text: data[0].text};
                        self.customersArr = data;
                        // console.log(self.customersArr.data());
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            loadUser: function (loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/users",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search,
                        type: 'collector',
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.userArr = data;

                        // console.log(self.customerArr.data());
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            loadCustomer: function (loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/customers",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.customersArr = data;

                        // console.log(self.customerArr.data());
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            loadCalls(loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get_contacts",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.contactsArr = data;

                        // console.log(self.customerArr.data());
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            AddCall(flag) {
                this.$validator.validate().then(result => {
                    if (result) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        var self = this;
                        //console.log(segments[3]);
                        if (segments[2] == 'update') {
                            if (segments[3]) {
                                //console.log(segments[3]);
                                $("#addCallBtn").val("Updating ...");
                                $("#addCallBtn").prop("disabled", true);
                                // $("#addAndContinueCaseBtn").prop('disabled',true);
                                $("#CancelCall").prop("disabled", true);
                            } else {
                                if (flag == "Save and Continue") {
                                    $("#addAndContinueCallBtn").val("Saving ...");
                                    $("#addAndContinueCallBtn").prop("disabled", true);
                                    $("#addCallBtn").prop("disabled", true);
                                    $("#CancelCall").prop("disabled", true);
                                } else {
                                    $("#addCallBtn").val("Saving ...");
                                    $("#addCallBtn").prop("disabled", true);
                                    $("#addAndContinueCallBtn").prop("disabled", true);
                                    $("#CancelCall").prop("disabled", true);
                                }
                            }
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueCallBtn").val("Saving ...");
                                $("#addAndContinueCallBtn").prop("disabled", true);
                                $("#addCallBtn").prop("disabled", true);
                                $("#CancelCall").prop("disabled", true);
                            } else {
                                $("#addCallBtn").val("Saving ...");
                                $("#addCallBtn").prop("disabled", true);
                                $("#addAndContinueCallBtn").prop("disabled", true);
                                $("#CancelCall").prop("disabled", true);
                            }
                        }
                        var fields = $("#callfrom").serializeArray();

                        fields.push({name: "priority", value: self.priority.value});
                        // fields.push({name: "direction", value: self.direction.value});
                        // fields.push({name: "type", value: self.callType.value});
                        fields.push({name: "category", value: self.category.value});
                        fields.push({name: "customer_id", value: self.customer_id.value});
                        fields.push({name: "contact_id", value: self.contact_id.value});
                        fields.push({name: "user_id", value: self.user_id.value});
                        fields.push({name: "due_date", value: self.due_date});
                        fields.push({name: "status", value: ''});
                        if (self.status != '' && self.status != null && self.status.value) {
                            fields.push({name: "status", value: self.status.value});
                        }
                        if (segments[2] == 'update') {
                            if (segments[3]) {
                                fields.push({name: "id", value: segments[3]});
                            } else {
                                fields.push({name: "id", value: 0});
                            }
                        } else {
                            fields.push({name: "id", value: 0});
                        }

                        self.showLoader();
                        $.ajax({
                            url: process.env.ROOT_API + "/call/create",
                            type: "POST",
                            data: fields,
                            headers: {
                                Accept: "application/json",
                                "Access-Control-Allow-Origin": "*",
                                Authorization: "Bearer " + localStorage.getItem("api_token"),
                                "Access-Control-Allow-Headers":
                                        "Origin, Content-Type, Authorization,X-Requested-With",
                                "Cache-Control": "no-cache"
                            },
                            dataType: "json",
                            success: function (data) {
                                self.hideLoader();
                                if (segments[2] == 'update') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addCallBtn").val("Update");
                                        $("#addCallBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelCall").prop("disabled", false);
                                        Swal.fire(
                                            'Updated!',
                                            self.LabelName('callsemaillabel') +' updated successfully.',
                                            'success'
                                        )
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueCallBtn").val("Save and Continue");
                                            $("#addAndContinueCallBtn").prop("disabled", false);
                                            $("#addCallBtn").prop("disabled", false);
                                            $("#CancelCall").prop("disabled", false);
                                        } else {
                                            $("#addCallBtn").val("Save");
                                            $("#addCallBtn").prop("disabled", false);
                                            $("#addAndContinueCallBtn").prop("disabled", false);
                                            $("#CancelCall").prop("disabled", false);
                                            Swal.fire(
                                                'Updated!',
                                                self.LabelName('callsemaillabel')+' updated successfully.',
                                                'success'
                                            )
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueCallBtn").val("Save and Continue");
                                        $("#addAndContinueCallBtn").prop("disabled", false);
                                        $("#addCallBtn").prop("disabled", false);
                                        $("#CancelCall").prop("disabled", false);
                                    } else {
                                        $("#addCallBtn").val("Save");
                                        $("#addCallBtn").prop("disabled", false);
                                        $("#addAndContinueCallBtn").prop("disabled", false);
                                        $("#CancelCall").prop("disabled", false);
                                        Swal.fire(
                                            'Added!',
                                            self.LabelName('callsemaillabel') + ' added successfully.',
                                            'success'
                                        )
                                    }
                                }

                                if (data.status == "success") {
                                    if (flag == "Save and Continue") {
                                        $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").parent().addClass("show");
                                        $(".alert-success").parent().removeClass("hide");
                                        self.user_id = "";
                                        self.subject = "";
                                        self.notes = "";
                                        self.call_date_time = null;
                                        self.direction = {value: "outgoing", text: "Outgoing"};
                                        self.callType = {value: "call", text: "Call"};
                                        self.category = {value: "afda", text: "AFDA"};
                                        self.priority = {value: "medium", text: "Medium"};
                                        self.customer_id = "";
                                        self.status = "";
                                        self.due_date = "";
                                        self.contact_id = "";
                                        $("#call_date_time").val("");
                                        self.userArr = [];
                                        self.customersArr = [];
                                        if (segments[3] != 0) {
                                            self.customerId = segments[3];
                                            self.loadCustomeradd();
                                        }
                                        self.setDefaultCallDate();
                                        setTimeout(function () {
                                            $(".alert-success").parent().removeClass("show");
                                            $(".alert-success").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        self.back();
                                    }
                                } else {
                                    //console.log(data.content);
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (segments[2] == 'update') {
                                    if (segments[3]) {
                                        $("#addCallBtn").val("Update");
                                        $("#addCallBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelCall").prop("disabled", false);
                                        self.user_id = "";
                                        self.subject = "";
                                        self.notes = "";
                                        self.call_date_time = null;
                                        self.direction = {value: "", text: "Select Direction"};
                                        self.callType = {value: "", text: "Select Call"};
                                        self.category = {value: "afda", text: "AFDA"};
                                        self.customer_id = "";
                                        self.contact_id = "";
                                        self.priority = {value: "", text: "Select Priority"};
                                        $("#call_date_time").val("");
                                        self.userArr = [];
                                        self.status = "";
                                        self.due_date = "";
                                        self.customersArr = [];
                                        if (segments[3] != 0) {
                                            self.customerId = segments[3];
                                            self.loadCustomeradd();
                                        }
                                        self.setDefaultCallDate();
                                        // $("#call_date_time").val('');
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueCallBtn").prop("disabled", false);
                                            $("#addAndContinueCallBtn").val("Save and Continue");
                                            $("#addCallBtn").prop("disabled", false);
                                            $("#CancelCall").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            if (segments[3] != 0) {
                                                self.customerId = segments[3];
                                                self.loadCustomeradd();
                                            }
                                            self.setDefaultCallDate();
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addCallBtn").val("Save");
                                            $("#addCallBtn").prop("disabled", false);
                                            $("#addAndContinueCallBtn").prop("disabled", true);
                                            $("#CancelCall").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueCallBtn").prop("disabled", false);
                                        $("#addAndContinueCallBtn").val("Save and Continue");
                                        $("#addCallBtn").prop("disabled", false);
                                        $("#CancelCall").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        if (segments[3] != 0) {
                                            self.customerId = segments[3];
                                            self.loadCustomeradd();
                                        }
                                        self.setDefaultCallDate();
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addCallBtn").val("Save");
                                        $("#addCallBtn").prop("disabled", false);
                                        $("#addAndContinueCallBtn").prop("disabled", true);
                                        $("#CancelCall").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }
                                if (jqXHR.status == 0) {
                                    self.errorMsg = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                }
                            }
                        });
                    }
                });
            },

            loadCall() {
                var path = window.location.pathname;
                var segments = path.split("/");
                //console.log(segments[3]);
                var self = this;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/call/" + segments[3],
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        // if (data.created_by == self.loginID) {
                            //console.log(data);

                            self.user_id = {
                                value: data.uid,
                                text:
                                        data.user_firstname +
                                        " " +
                                        data.user_lastname /*+
                                         " - " +
                                         data.user_email*/
                            };
                            self.subject = data.subject;
                            self.notes = data.notes;
                            $("#call_date_time").val(data.call_date_time);
                            self.call_date_time = data.call_date_time;
                            self.direction = {
                                value: data.direction,
                                text: self.formatString(data.direction)
                            };
                            self.call_type = data.call_type;
                            if (data.call_type == 'email') {
                                self.callType = {
                                    value: data.call_type,
                                    text: 'E-Mail'
                                };
                            } else if (data.call_type == 'dunning_notice') {
                                self.callType = {
                                    value: data.call_type,
                                    text: 'Dunning Notice'
                                };
                            } else {
                                self.callType = {
                                    value: data.call_type,
                                    text: 'Call'
                                };
                            }

                            if (data.category){
                                self.category = {
                                    value: data.category,
                                    text: data.category.toUpperCase()
                                };
                            }else{
                                self.category = "";
                            }

                            self.customer_id = {
                                value: data.cid,
                                text: data.first_name + " (" + data.cusid + ")"
                            };
                            self.contact_id = {
                                value: data.contact_id,
                                text: data.contact_first_name
                            };
                            self.selectedContactId = data.contact_id;
                            self.priority = {
                                value: data.priority,
                                text: self.formatString(data.priority)
                            };
                            self.isDataEditable = true;

                            if (data.status != '' && data.status != null) {
                                self.status = {text:data.status_formatted,value:data.status};
                            }
                            self.due_date = data.due_date;
                        // } else {
                        //     self.isDataEditable = false;
                        // }
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            menuSmall: function () {
                $(".opensidebar").show();
                $(".closesidebar").hide();
                $(".menu").addClass("menusmall");
                $(".sidemenu li a span,.legal").addClass("displaynone");
                $(".sidemenu li a i").addClass("displayicons");
                $(".sidebar").css({width: "70px"});
                $(".content").css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $(".opensidebar").hide();
                $(".closesidebar").show();
                $(".menu").removeClass("menusmall");
                $(".sidemenu li a span,.legal").removeClass("displaynone");
                $(".sidemenu li a i").removeClass("displayicons");
                $(".sidebar").css({width: "260px"});
                $(".content").css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            }
        }
    };
    EventBus.$on('logged-in', function (isLogin, fname, lname, email) {
        if (typeof (contex) != "undefined") {
            contex.isShowLoggedinfields = isLogin;
            contex.firstName = fname;
            contex.lastName = lname;
            contex.userName = email;
        }

    });
</script>


// WEBPACK FOOTER //
// src/components/callsAndEmails/callCreate.vue